export { differenceInSeconds } from "date-fns";

export const DEV_SIGN_UP = "https://int-id.cisco.com/signin/register";
export const PROD_SIGN_UP = "https://id.cisco.com/signin/register";

export const DEV_NEED_HELP = "https://int-id.cisco.com";
export const PROD_NEED_HELP = "https://id.cisco.com";

const EMAIL_REGEX =
  /^(?:[a-zA-Z0-9]+\/)?[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Email validation function
 * @param value
 */
export function isEmail(value: FormDataEntryValue | null): boolean {
  if (value) {
    if (!(value instanceof File)) {
      return EMAIL_REGEX.test(value);
    }
  }
  return false;
}

export const noop = () => {};

// Note: All path should be kebab-case
export const PATHS = {
  ADD_ORG: "add-org",
  BEARER_TOKEN: "bearer-tokens",
  BGP_PEER: "bgp-peer",
  BOT_MGMT: "bot-management",
  CANDIDATE: "candidate",
  CERT_MGMT: "root-certificates",
  CERT_SRVR_MGMT: "server-certificates",
  CHASSIS: "node",
  DEV: "dev",
  DEVICES: "devices",
  DEVICES_TOKENS: "device-tokens",
  DIFF: "diff",
  DEV_LOGIN: "dev-login",
  DYNAMIC_BGP_PEER: "dynamic-bgp-peer",
  SWITCH_FABRICS: "switch-fabrics",
  EVENT_VIEWER: "event-viewer",
  FABRIC: "fabric",
  FEATURE_PREVIEW: "feature-preview",
  FABRIC_DESIGNER: "fabric-designer",
  FABRIC_INTERCONNECTS: "fabric-interconnects",
  FABRIC_TEMPLATES: "fabric-templates",
  FABRICS: "fabrics",
  INSIGHTS: "insights",
  INVENTORY: "inventory",
  INVENTORY_COUNTS: "inventory-counts",
  LOGIN: "login",
  MONITORED_VNI: "monitored-vni",
  MONITORED_VRF: "monitored-vrf",
  MULTISITE: "multisite",
  NETWORK_QUALITY: "network-quality",
  NETWORK_QUALITY_BETA: "network-performance-monitoring",
  NOTIFICATION_ENDPOINTS: "endpoints",
  NOTIFICATION_POLICIES: "policies",
  NOTIFICATIONS: "notifications",
  ON_SITE: "on-site",
  ORG_SETTINGS: "organization-settings",
  POLICY: "policy",
  PORT: "port",
  PORT_CHANNEL: "port-channel",
  RACK: "rack",
  STATE_COMPARISON: "state-comparison",
  REVIEW: "review",
  SERVER: "server",
  SOFTWARE_MANAGEMENT: "software-management",
  SPYGLASS: "spyglass",
  STATIC_ROUTES: "staticRoutes",
  SUBSCRIPTION: "subscription",
  SUBSCRIPTION_MANAGEMENT: "management",
  SUBSCRIPTION_USAGE: "usage",
  SUBSCRIPTION_USAGE_BY_PRODUCT: "product-usage",
  SUMMARY: "summary",
  SW_QR_CODE: "sw",
  TASKS: "tasks",
  TOKEN_MANAGEMENT: "api-bearer-tokens",
  USER_MGMT: "user-management",
  VLAN_MEMBERSHIP: "vlanMembership",
  VNI: "vni",
  VRF: "vrf",
  MOCK_SHELL: "mock-shell"
} as const;
export const REFRESH_WINDOW = 60 * 5; // 5 minutes in seconds
export const MIN_REFRESH_INTERVAL = 60; // 1 minute in seconds
export const IDLE_TIMEOUT = 60 * 30; // 30 minutes in seconds
// See pagination rules in the code guidelines
export const LARGE_TABLE_PAGINATION = 100;
export const MEDIUM_TABLE_PAGINATION = 50;
export const SMALL_TABLE_PAGINATION = 20;
export const API_HISTORY_LIMIT = 50; // max entries kept in unary/REST debug history

export const BIDIRECTIONAL_ARROW = "\u2194"; // ↔
